import { useEffect, useState } from 'react';
import { StreamrTvBroadcaster } from '../engine/StreamrTvBroadcaster';
import { useSetViewerCountCallback } from '../state/viewerCountState';
export function useStreamrTvBroadcaster(streamPartId) {
    const [broadcaster, setBroadcaster] = useState();
    const setViewerCountCallback = useSetViewerCountCallback();
    useEffect(function setupBroadcaster() {
        if (!setViewerCountCallback) {
            return;
        }
        let mounted = true;
        function onViewerCountChanged(streamPartId, count) {
            setViewerCountCallback(streamPartId, count);
        }
        const newBroadcaster = new StreamrTvBroadcaster();
        newBroadcaster.on('viewerCountChanged', onViewerCountChanged);
        (async () => {
            try {
                await newBroadcaster.start(streamPartId);
                if (!mounted) {
                    return;
                }
                setBroadcaster(newBroadcaster);
            }
            catch (e) {
                console.error(e);
            }
        })();
        return () => {
            mounted = false;
            newBroadcaster?.off('viewerCountChanged', onViewerCountChanged);
            newBroadcaster?.stop().catch(console.error.bind(console));
        };
    }, [setViewerCountCallback, streamPartId]);
    return broadcaster;
}
